import script from "./SearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=43b7c5d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b7c5d8"]])

export default __exports__